module.exports = __webpack_public_path__ + "img/thumb_33.faa38383.jpg";